<div class="page-data">
    <app-advanced-search (formData)="applyFilters($event)" [config]="filterConfig"> </app-advanced-search>
    <div class="p-relative c-table">
        <app-common-table
            [config]="tableConfig"
            [service]="projectTableService"
            (actions)="applyAction($event)"
        >
        </app-common-table>
    </div>
</div>
